import React from "react";

export default () => {
  return (
    <>
      <h1>IKK Szakképesítés aloldal</h1>
    </>
  );
};
